import { Mesh, ShaderMaterial, MeshPhongMaterial, Color } from "three";
const strokeColor = 0x000000;
const wireframeBackgroundColor = 0xffffff;
export function applyColorsToMesh(mesh, customColor) {
    mesh.traverse((child) => {
        if (child instanceof Mesh) {
            changeColorsOfChild(child, strokeColor, wireframeBackgroundColor, customColor);
        }
    });
}
function changeColorsOfChild(child, strokeColor, baseColor, customColor) {
    if (child.material instanceof ShaderMaterial) {
        const uniforms = child.material.uniforms;
        uniforms.strokeColor.value.setHex(strokeColor);
        uniforms.baseColor.value.setHex(baseColor);
    }
    else if (child.material instanceof MeshPhongMaterial) {
        const darkenedCustomColor = new Color(customColor).multiplyScalar(0.5);
        child.material.color = new Color(darkenedCustomColor);
        child.material.emissive = new Color(darkenedCustomColor);
    }
}
